<template lang="pug">
v-container
  v-row
    v-col(cols="12")
      v-card(max-width="700px" outlined).pa-4.ma-auto
        h1.text-center.mb-4 Cоздание тестового вопроса
        v-form(v-model="valid")
          v-text-field(
            filled
            v-model="form.text"
            label="Тема вашего вопроса"
            :rules="[rules.required]"
          )
          v-card.pa-4(outlined).mb-2
            .d-flex(style="overflow-x:auto")
              uploader(@upload="uploadFile($event)")
                template(#activator)
                  v-btn.mr-4(color="success" height="80px" width="80px")
                    v-icon mdi-plus
              Element(
                  v-for="(file, index) in [...form.documents,...form.images]"
                :key="index"
                show-actions
                :show-edit="false"
                :name="file.original_name"
                :url="file.url"
                @delete="form.files.splice(index, 1)"
              )

          select-project(
            :rules="[rules.required]"
            v-model="form.project_id"
            filled
          )
          select-template-category(
            v-model="form.question_category_id"
            :disabled="!form.project_id"
            :project-id="form.project_id"
            filled
            label="Выберите вашу категорию"
          )
          v-textarea(
            filled
            label="Текст вашего вопроса"
            :rules="[rules.required]"
            v-model="form.full_text"
          )

          v-text-field(
            v-model="form.email"
            type="email"
            :rules="[rules.email]"
            filled
            label="Оставьте ваш рабочий email для связи"
          )
          v-text-field(
            v-model="form.organization_name"
            filled
            :rules="[rules.required]"
            label="Наименование вашей организации"
          )
          v-text-field(filled v-model="form.role_name"
            label="Ваша роль"
            :rules="[rules.required]"
          )

          select-region(
            filled
            label="Выберите ваш регион"
            v-model="form.region_id"
            :rules="[rules.required]"
          )

          select-mun(
            filled
            label="Выберите ваш мунципалитет"
            v-model="form.municipality_id"
          )

          v-btn(
            @click="submit"
            color="success"
            :disabled="!valid"
          ) Отправить
</template>
<script>
import { isImage } from '@/lib';
import { mapGetters } from 'vuex';
import rules from '@/lib/rules';
import SelectMun from '@/components/inputs/SelectMun.vue';
import SelectRegion from '@/components/inputs/SelectRegion.vue';
import clientQuestionService from '@/services/API/client-questions';
import Uploader from '@/components/core/Uploader.vue';
import Element from '@/components/icons/Element.vue';
import SelectProject from '@/components/inputs/SelectProject.vue';
import SelectTemplateCategory from '@/components/inputs/SelectTemplateCategory.vue';

const DEFAULT_FORM = {
  'project_id': 1,
  'question_category_id': null,
  'email': 'help@pfdo.ru',
  'username': null,
  'text': 'У меня проблема',
  'full_text': 'Кнопка не работает',
  'role_name': 'Организация',
  'organization_name': 'ООО Копыта',
  'region_id':1,
  'municipality_id': 1,
  'browser_history':[],
  'page_url':'',

  'images':[],
  'documents':[],
};

export default {
  components: {
    Element,
    SelectMun,
    SelectRegion,
    Uploader,
    SelectProject,
    SelectTemplateCategory,
  },
  data() {
    return {
      valid: false,
      rules,
      form: { ...DEFAULT_FORM },
    };
  },
  computed: {
    ...mapGetters({
      user:'auth/getUser',
    }),
  },
  methods: {
    async submit() {
      if (!this.valid) return;
      try {
        this.form.page_url = window.location.href;
        if (this.user.username) {
          this.form.username = this.user.username;
        } else {
          delete this.form.username;
        }
        await clientQuestionService.post(this.form);
        this.$toast.success('Ваше обращение отправлено');
        this.form = { ...DEFAULT_FORM };
      } catch (err) {
        const message = err.response.data?.result_message;
        this.$toast.error(message);
      }
    },
    uploadFile(file) {
      if (isImage(file.file_name)) {
        this.form.images.push(file.file_name);
      } else {
        this.form.documents.push(file.file_name);
      }
    },
  },
};
</script>
